<style lang="scss">
    .packages {
        .discounts-title {
            color: #FF5B94;
            margin-top: 40px;
            text-transform: uppercase;
            font-size: 30px !important;
        }
        
        .discounts-description {
            margin-bottom: 20px;
        }

        .discounts-wrapper{
            display: flex;
            margin-left: -10px;
            margin-right: -10px;
            margin-top: 10px;
            align-items: flex-start;
            justify-content: center;
            flex-wrap: wrap;

            .beat-discount-container {
                flex: 1;
                max-width: 190px;
                min-width: 190px;
                margin: 1rem;
                min-height: 200px;
            }
            
            @media screen and (max-width: 768px) {
                flex-direction: column;
                align-items: center;

                .beat-discount-container {
                    margin: 1rem;
                    width: 80%;
                }
            }
        }

        @media screen and (max-width: 650px) {
            padding: 0 14px;
        }
    }
</style>

<template>
    <div class="packages">
        <h1 class="discounts-title" :style="$highlightColor">PACKAGE DISCOUNTS</h1>
        <p class="discounts-description" :style="$mainSecondaryTextStyle">Add multiple beats of the same license type to automatically activate the discount packages.</p>
        <div class="discounts-wrapper">
            <template v-for="(price, index) in prices" >
                <discount-row :price="price" :imgIndex="index" :key="price.id" v-if="price.discounts.length"></discount-row>
            </template>
        </div>
    </div>
</template>

<script>
    import DiscountRow from './discountcontainer.vue'
    import Configure from './../mixins/configure'

    export default {
        components: {
           DiscountRow
        },
        props:['prices'],
        data() {
            return {
                beat: false
            }
        },
        mixins: [Configure]        
    }
</script>